import { useDashboard } from '../api/hooks';
import { OrdersTable } from '../components/OrdersTable';
import { fmtAmt } from '@wave/shared';
import {
  pageContainer,
  pageHeader,
  pageTitle,
  sectionTitle,
} from '../lib/styles';

interface CardProps {
  label: string;
  value: string | number;
  hint?: string;
  tone?: 'default' | 'success' | 'warning';
  numeric?: boolean;
}

function Card({ label, value, hint, tone = 'default', numeric = false }: CardProps) {
  const valueCls =
    tone === 'success' ? 'text-success' : tone === 'warning' ? 'text-warning' : 'text-text';
  return (
    <div className="rounded-lg border border-border bg-bg2 p-5 transition-colors duration-150 hover:border-border-strong">
      <div className="text-[11px] font-medium uppercase tracking-wide text-text2">{label}</div>
      <div className={`mt-1.5 text-2xl font-bold tracking-tight ${numeric ? 'font-mono tabular-nums' : ''} ${valueCls}`}>
        {value}
      </div>
      {hint && <div className="mt-1 text-xs text-text2">{hint}</div>}
    </div>
  );
}

export function DashboardPage() {
  const { data, isLoading, error } = useDashboard();

  return (
    <div className={pageContainer}>
      <div className={pageHeader}>
        <h1 className={pageTitle}>Дашборд</h1>
      </div>

      {isLoading && <div className="text-sm text-text2">Загрузка…</div>}
      {error && (
        <div className="rounded-md border border-[var(--red-border)] bg-[var(--red-bg)] px-3 py-2 text-sm text-danger">
          {(error as Error).message}
        </div>
      )}

      {data && (
        <>
          <div className="mb-8 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
            <Card label="Заявок всего" value={data.cards.ordersTotal} numeric />
            <Card label="В работе" value={data.cards.inWork} tone="warning" numeric />
            <Card label="Закрыто сегодня" value={data.cards.closedToday} tone="success" numeric />
            <Card
              label="Профит сегодня"
              value={fmtAmt(data.cards.profitTodayUsdt, 'USDT')}
              tone="success"
              numeric
            />
            <Card
              label="Профит за месяц"
              value={fmtAmt(data.cards.profitMonthUsdt, 'USDT')}
              tone="success"
              numeric
            />
            <Card label="Открытых проводок" value={data.cards.openProvodki} numeric hint="ожидают подтверждения" />
          </div>

          <h2 className={`${sectionTitle} mb-3`}>Последние заявки</h2>
          <OrdersTable orders={data.recentOrders} />
        </>
      )}
    </div>
  );
}
